<template>
  <div>

    <text-box-title title="Friendship Park Fishing Rules" class="mt-3">
      <div class="col-md-6 mt-3">
        <p>
          Fishing is allowed from dawn until dusk unless you are camping and except for special events. Campers may night fish in accordance with camping rules.
        </p>
        <p>
          With the exception of carp, all fish caught are to be immediately released alive. Deeply hooked fish are to be released by cutting 
          the leader so as not to damage the fish. No fish except carp may be on a stringer.
        </p>
      </div>

      <div class="col-md-6 mt-3">
        <ul class="fishing-list">
          <li>
            Carp are catch and keep.
          </li>
          <li>
            No bow fishing. No jug fishing. No trout line.
          </li>
          <li>
            One rod per fisherman.
          </li>
          <li>
            Children under sixteen may fish as long as they are supervised by a parent or responsible adult 18 years or older and acting as guardian.
          </li>
          <li>
            Fishermen are to abide by all park rules and camping rules.
          </li>
          <li>
            Gas engines are permitted for boats, however there is a 9.9 horsepower limit. One electric motor per boat.
          </li>
        </ul>
      </div>
    </text-box-title>

  </div>
</template>

<script>
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import ResponseItem from '@/components/layout/ResponseItem.vue'

export default {
  components: {
    TextBoxTitle,
    ResponseItem
  },
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style scoped>
  .fishing-list > li{
    margin-bottom: 0.75em;
    margin-left: 15px;
  }
</style>